<script>
  import { validationMixin } from 'vuelidate'
  import { required, minLength } from 'vuelidate/lib/validators'

  export default {
    mixins: [validationMixin],
    data() {
      return {
        loading: false,
        old_password: null,
        new_password: null
      }
    },

    validations: {
      old_password: {
        required
      },
      new_password: {
        required,
        minLength: minLength(8)
      }
    },

    methods: {
      save() {
        this.$v.$touch()

        if (this.$v.$error) {
          return
        }

        this.loading = true

        this.axios.post('/change-password', {
          old_password: this.old_password,
          new_password: this.new_password
        })
        .then(() => {
          this.$v.$reset()
          this.old_password = ''
          this.new_password = ''

          this.$store.dispatch('Alerts/add', {
            trans: 'messages.password_updated',
            type: 'success'
          })
        })
        .finally(() => {
          this.loading = false
        })
      }
    }
  }
</script>

<template>
  <form class="columns is-multiline" @submit.prevent="save">
    <div class="column is-12">
      <p class="control has-icon">
        <input class="input" :class="{'is-danger': $v.old_password.$error}" type="password" v-model="old_password" :placeholder="$t('register.field.old_password')">
        <span class="icon">
          <i class="fa fa-lock"></i>
        </span>
      </p>
      <p class="help is-danger" v-show="$v.old_password.$error &&!$v.old_password.required">
        {{ $t('validation.required') }}
      </p>
    </div>
    <div class="column is-12">
      <p class="control has-icon">
        <input class="input" :class="{'is-danger': $v.new_password.$error}" type="password" v-model="new_password" :placeholder="$t('register.field.new_password')">
        <span class="icon">
          <i class="fa fa-lock"></i>
        </span>
      </p>
      <p class="help is-danger" v-show="$v.new_password.$error &&!$v.new_password.required">
        {{ $t('validation.required') }}
      </p>
      <p class="help is-danger" v-show="$v.new_password.$error &&!$v.new_password.minLength">
        {{ $t('validation.min.string', {min: 8}) }}
      </p>
    </div>
    <div class="register-form_actions column is-12">
      <button class="button is-danger is-fullwidth" :class="{'is-loading': loading}" type="submit">{{ $t('buttons.update') }}</button>
    </div>
  </form>
</template>



// WEBPACK FOOTER //
// ChangePasswordForm.vue?58c0c9b1